import { Icon, InputAdornment } from "@material-ui/core";
import { Event } from "@material-ui/icons";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import React, { useState } from "react";

const momentFromStr = (obj) => {
  if (typeof obj == "string") return moment(obj.split("/").reverse().join("-"));
  return obj;
};

export default ({ field, handleBlur, ...props }) => {
  const [state, setState] = useState(field.value);
  const handleChange = (val) => setState(val);

  const blurHandler = (time) => {
    const target = {
      target: {
        ...field,
        value: time,
      },
    };
    handleBlur(target);
  };

  return (
    <>
      <KeyboardDatePicker
        inputProps={{
          fieldid: field.id,
        }}
        label={field.label}
        onAccept={(date) => setState(date)}
        format="dd/MM/yyyy"
        disableToolbar
        variant="inline"
        value={state == "" ? null : momentFromStr(state)}
        invalidDateMessage={null}
        inputValue={
          state == null || state == ""
            ? null
            : momentFromStr(state).format("DD/MM/YYYY")
        }
        inputVariant="outlined"
        onChange={handleChange}
        onAccept={blurHandler}
        KeyboardButtonProps={{
          className: "p-0",
        }}
        keyboardIcon={
          field.updating ? (
            <InputAdornment position="end">
              <Icon className="fas fa-sync fa-spin m-color-blue" />
            </InputAdornment>
          ) : (
            <InputAdornment position="end">
              <Event className="fa-solid fa-calendar-day" />
            </InputAdornment>
          )
        }
        {...props}
      />
    </>
  );
};
